import { api } from '@xarvio/frontend-core-platform/lib/api';
import { SettingsType } from './types';

const microservice = 'users';

export const getSettings = () => {
  return api.get<void, SettingsType[]>(`${microservice}/settings`);
};

export const putSetting = async (setting: SettingsType) => {
  const uuid = setting.uuid;
  const { lastUpdated: _, userId: __, ...rest } = setting;

  return api.put<any, SettingsType>(
    `${microservice}/settings/${uuid}`,
    JSON.stringify(rest),
  );
};
